import { FC, ReactElement } from 'react';

import { Button, Col, Modal, Row } from 'antd';
import cs from 'classnames';

import { DialogModalTypes } from 'constants/enums';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import styles from './DialogModal.module.scss';

interface DialogModalProps {
  isOpen: boolean;
  type: DialogModalTypes;
  onClose: () => void;
  onConfirm?: () => void;
  title?: string;
  // to make text partially bold please use <>text <strong>bold text</strong></>
  description?: string | ReactElement;
  isLoading?: boolean;
}

const MODAL_WIDTH = '550px';

const DialogModal: FC<DialogModalProps> = ({
  isOpen,
  type,
  onClose,
  onConfirm,
  title,
  description,
  isLoading = false
}) => {
  const BUTTON_TEXT = {
    [DialogModalTypes.Confirm]: 'Agree',
    [DialogModalTypes.OK]: 'OK'
  };

  const confirmButton = (
    <Button
      type="primary"
      className={cs(styles.button, styles.submitButton)}
      onClick={onConfirm}
      disabled={isLoading}
      loading={isLoading}
    >
      {BUTTON_TEXT[type]}
    </Button>
  );

  const CONFIG = {
    [DialogModalTypes.Confirm]: {
      title: 'Agree',
      button: confirmButton
    },
    [DialogModalTypes.OK]: {
      title: 'OK',
      button: confirmButton
    }
  };

  return (
    <Modal
      className={styles.container}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={MODAL_WIDTH}
      title={title || CONFIG[type].title}
      closeIcon={<CloseIcon aria-label="Close modal" />}
      destroyOnClose
    >
      {description && (
        <Row>
          <Col span={24} className={styles.description}>
            {description}
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24}>
          <div className={styles.buttons}>
            <Button
              className={cs(styles.button, styles.cancelButton)}
              type="primary"
              onClick={onClose}
              loading={isLoading}
            >
              Cancel
            </Button>
            {CONFIG[type].button}
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default DialogModal;
